<template>
    <div class="journal-show-component">
        <div class="row title text-center" :style="backgroundImage(featuredImage)">
            <div class="overlay"></div>
            <div class="col-12 my-auto px-5">
                <h1>{{ title }}</h1>
                <p><strong>{{ datePosted }} - {{ author }}</strong></p>
            </div>
        </div>
        <div class="container body">
            <div class="row">
                <div class="col-12 contents" v-html="contents"></div>
            </div>
        </div>
    </div>
</template>


<script>
import axios from 'axios';

export default {
    name: 'Post',
    data() {
        return {
            author: undefined,
            datePosted: undefined,
            featuredImage: undefined,
            title: undefined,
            contents: undefined
        }
    },
    mounted() {
        const slug = window.location.pathname.split('/').pop();
        axios.get(`/journals/${slug}`).then(response => {
            this.author = response.data.journal.author;
            this.datePosted = response.data.journal.created_at;
            this.featuredImage = response.data.journal.image;
            this.title = response.data.journal.title;
            this.contents = response.data.journal.body;
        });
    },
    methods: {
        backgroundImage(imageUrl) {
            return {
                backgroundImage: `url(${imageUrl})`
            };
        }
    }
}
</script>

<style lang="sass" scoped>
h1
    font-family: "Might Could"
    font-size: 4rem

.title
    background-size: cover
    background-repeat: no-repeat
    background-position: center center
    height: 400px
    position: relative

.overlay
  position: absolute
  width: 100%
  height: 100%
  opacity: 0.75
  background-color: $gray  

.body
    margin-top: 5rem

.contents > p
    color: $dutche-primary-violet !important
    font-family: "Gotham" !important
</style>
